var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState, useCallback } from 'react';
import cx from 'classnames';
import { usePopper } from 'react-popper';
import useHover from '../../../utils/use-hover';
import styles from './Content.module.scss';
import useOnClickOutside from '../../../utils/use-on-click-outside';
import useOnKeyupOutside from '../../../utils/use-on-keyup-outside';
import { useAccessibleMenu } from '../../../core/hooks/useAccessibleMenu';
export var Content = function (_a) {
    var handleClose = _a.handleClose, _b = _a.direction, direction = _b === void 0 ? 'bottom-start' : _b, referenceElement = _a.referenceElement, handleItemSelect = _a.handleItemSelect, className = _a.className, closeOnClick = _a.closeOnClick, closeOnScroll = _a.closeOnScroll, props = __rest(_a, ["handleClose", "direction", "referenceElement", "handleItemSelect", "className", "closeOnClick", "closeOnScroll"]);
    var classNames = cx(styles.content, className);
    var _c = useState(null), popperElement = _c[0], setPopperElement = _c[1];
    var _d = useHover(), hoverRef = _d.hoverRef, isHovering = _d.isHovering;
    var setContentNode = function (node) {
        hoverRef(node);
        setPopperElement(node);
    };
    useOnClickOutside([{ current: popperElement }, referenceElement], handleClose);
    useOnKeyupOutside([{ current: popperElement }, referenceElement], function (event) { return handleClose(event, false); });
    var keydownEventListener = useCallback(function (event) {
        if (event.key === 'Esc' || event.key === 'Escape') {
            handleClose(event);
        }
    }, [handleClose]);
    var scrollEventListener = useCallback(function (event) {
        if (!isHovering) {
            handleClose(event);
        }
    }, [handleClose, isHovering]);
    useEffect(function () {
        document.addEventListener('keydown', keydownEventListener);
        return function () {
            document.removeEventListener('keydown', keydownEventListener);
        };
    }, [keydownEventListener]);
    useEffect(function () {
        if (closeOnScroll) {
            document.addEventListener('scroll', scrollEventListener);
        }
        return function () {
            document.removeEventListener('scroll', scrollEventListener);
        };
    }, [closeOnScroll, scrollEventListener]);
    var menuHandles = useAccessibleMenu({ current: popperElement }, __assign({ handleItemSelect: handleItemSelect, menuItemSelector: '[data-accessible-menu]' }, (closeOnClick ? { handleClose: handleClose } : {})));
    var _e = usePopper(referenceElement.current, popperElement, {
        placement: direction,
        modifiers: [
            {
                name: 'flip',
                enabled: false,
            },
        ],
    }), popperStyles = _e.styles, attributes = _e.attributes;
    return (React.createElement("div", __assign({ ref: setContentNode, style: popperStyles.popper, className: classNames }, menuHandles, attributes.popper, props)));
};
//# sourceMappingURL=Content.js.map